export const deliveryStartReceivingToJSON = (
	payload: IWarehouseStartReceivingDeliveryFormPayload,
): IWarehouseStartReceivingDeliveryPayload => ({
	delivery_document_number: payload.deliveryDocumentNumber.trim(),
	delivery_document_date: payload.deliveryDocumentDate.toISOString(),
	started_at: payload.receivedAt.toISOString(),
	temperature: payload.transportTemperature,
	vehicle_condition: payload.vehicleCondition,
	note: payload.comment?.trim() || null,
})

export const WarehouseExpectedDelivery = (json: IWarehouseExpectedDelivery): IWarehouseExpectedDeliveryModel => {
	const { facility_id, supplier_id, supplier_name, planned_delivery_date, items_count, ...rest } = json

	return {
		...rest,
		facilityID: facility_id,
		supplierID: supplier_id,
		supplierName: supplier_name,
		plannedDeliveryDate: new Date(planned_delivery_date),
		itemsCount: items_count,
	}
}
